export default __webpack_public_path__ + "static/media/pay_now.71c776ff.svg";